import * as React from "react";
import type { SVGProps } from "react";

export const ThumbsUpSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.5 -0.5 19.5 19.5" fill="none" {...props}>
    <path
      fill="currentColor"
      d="M3.656 7.875H.844A.844.844 0 0 0 0 8.719v8.437c0 .466.378.844.844.844h2.812a.844.844 0 0 0 .844-.844V8.72a.844.844 0 0 0-.844-.844M2.25 16.594a.844.844 0 1 1 0-1.688.844.844 0 0 1 0 1.688M13.5 2.864c0 1.49-.913 2.327-1.17 3.324h3.576c1.174 0 2.088.975 2.094 2.042.003.63-.265 1.31-.683 1.73l-.004.003c.346.82.29 1.97-.328 2.794.306.91-.002 2.029-.575 2.629.15.618.078 1.145-.217 1.569-.717 1.03-2.496 1.045-4 1.045h-.1c-1.697 0-3.086-.619-4.203-1.115-.56-.25-1.294-.559-1.85-.57a.42.42 0 0 1-.415-.42V8.378c0-.113.045-.22.125-.3 1.393-1.376 1.992-2.833 3.133-3.976.52-.522.71-1.31.893-2.071.156-.65.483-2.032 1.193-2.032.844 0 2.531.281 2.531 2.864"
    />
  </svg>
);
